import { OperationName } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const initiateOperation: (
  fetchContext: FetchContext,
  operationName: OperationName,
  accessToken?: string
) => Promise<void> = (fetchContext, operationName, accessToken) => {
  const params = new URLSearchParams();
  if (operationName) params.append('operationName', operationName);

  return fetch(`${fetchContext.baseUrl}/api/admin/operations/start${params.size > 0 ? `?${params}` : ''}`,
  {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
  }).then(response => responseErrorHandler<void>(fetchContext.errorStore, response, 'initiate operation'));
};
